import moment from 'moment';
const apiUrl = process.env.REACT_APP_API_URL;

export async function reviews() {
  const vehicleRatings = [
  {
    "reviewid": "f1a2b3c4-d5e6-7890-abcd-ef1234567890",
    "stars": 5,
    "name": "Maria Costa",
    "date": "2024-09-26",
    "text": "A nossa primeira viagem com uma autocaravana. Fomos um grupo de amigos e adorámos.\nAconselhamos a 100%. Empresa sempre disponível a qualquer horário para ajudar e esclarecer algo que fosse preciso. Serviço excelente mesmo.\nIremos voltar a repetir."
  },
  {
    "reviewid": "a9b8c7d6-e5f4-3210-ba98-76543210fedc",
    "stars": 5,
    "name": "Milene Pinho",
    "date": "2024-09-25",
    "text": "Autocaravana em perfeito estado. Holger muito atencioso, deu todas as dicas e informações importantes a quem está a viajar pela primeira vez numa autocaravana."
  },
  {
    "reviewid": "a1b2c3d4-e5f6-7890-ab12-cd34ef56gh78",
    "stars": 5,
    "name": "Ana Cristina",
    "date": "2024-09-25",
    "text": ""
  },
  {
    "reviewid": "b2c3d4e5-f6a7-8901-bc23-de45fg67hi89",
    "stars": 5,
    "name": "mário dias",
    "date": "2024-09-25",
    "text": "Excelente experiência!\nDesde o primeiro contacto até à devolução da autocaravana, fui presenteado com simpatia e profissionalismo. Excelente estado da autocacaravana, com equipamento interior 5☆!\n\nExperiência a repetir com toda a certeza. Haja tempo disponível!"
  },
  {
    "reviewid": "c3d4e5f6-a7b8-9012-cd34-ef56gh78ij90",
    "stars": 5,
    "name": "Margarida Correia",
    "date": "2024-09-25",
    "text": "Foi uma experiência incrível!\nA autocaravana tinha excelente condições e está como nova.\nUma experiência para a voltar a repetir de certeza absoluta 🥰"
  },
  {
    "reviewid": "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    "stars": 5,
    "name": "Carlo Naumann",
    "date": "2024-07-19",
    "text": "Wir haben jeweils ein Wohnmobil vom 06.-19.07.24 über Holger gemietet. Diese nahmen wir in Porto in Empfang und sind bis Lissabon gefahren.\nAlles hat super geklappt und der Service war prima. (inkl. Hol- und Bringeservice vom/zum Flughafen)"
  },
  {
    "reviewid": "e1f2a3b4-c5d6-7890-abcd-ef1234567890",
    "stars": 5,
    "name": "Тимофей Кунин",
    "date": "2024-03-29",
    "text": "Мы точно вернёмся ещё раз!\nВзяли автодом на неделю и были приятно удивлены его состоянием. Очень новый автодом, 2023 года. Очень чистый, всё работает исправно, машина пахнет новизной. Никаких проблем на маршруте не возникло. Мы очень благодарны!"
  },
  {
    "reviewid": "b2c3d4e5-f6a7-8901-bcde-f1234567890a",
    "stars": 5,
    "name": "Daniel Aragão",
    "date": "2024-02-09",
    "text": "Muito bom !! Com excelentes caravanas para alugar !!!"
  },
  {
    "reviewid": "c3d4e5f6-a7b8-9012-cdef-1234567890ab",
    "stars": 4,
    "name": "Lucy De Pereira",
    "date": "2023-10-11",
    "text": "Fui acompañar a una amiga .y fue un buen trato...."
  },
  {
    "reviewid": "d4e5f6a7-b8c9-0123-def0-1234567890ac",
    "stars": 5,
    "name": "Joaquim Salvador Costa",
    "date": "2023-08-03",
    "text": ""
  },
  {
    "reviewid": "e5f6a7b8-c9d0-1234-ef01-234567890abd",
    "stars": 5,
    "name": "Thomas G",
    "date": "2023-07-27",
    "text": "Eine unvergessliche Zeit voller Abenteuer und wundervoller Erinnerungen liegt hinter uns! Unser zweiwöchiger Urlaub im Wohnmobil in Portugal mit meinen drei Kindern war einfach atemberaubend, und wir können nicht genug positive Worte finden, um diese Erfahrung zu beschreiben.\n\nSchon bei der Ankunft waren wir beeindruckt von dem neuwertigen Wohnmobil. Es war mit allem ausgestattet, was wir für eine komfortable Reise benötigten und sogar noch mehr. Die große Markise bot uns angenehmen Schatten an heißen Tagen und ermöglichte es uns, unsere Mahlzeiten im Freien zu genießen. Die Tische und Stühle waren praktisch und bequem, und das Vorhandensein eines Fernsehers und WLANs war ein toller Bonus, besonders für die Kinder. Aber das Highlight für uns waren definitiv die Betten! Wir haben fantastisch geschlafen, und das ist ja gerade auf einer Reise mit Kindern von unschätzbarem Wert.\n\nEin großer Dank geht auch an Holger, der uns mit unschätzbaren Reisetipps versorgte. Dank seiner Insiderkenntnisse konnten wir spektakuläre Orte entdecken. Vom versteckten Waldparadies mit kristallklarem Wasser bis hin zu atemberaubenden Aussichtspunkten – Holger kannte sie alle! Die von ihm empfohlenen Aktivitäten waren genauso toll, und die Kinder hatten jede Menge Spaß. Es fühlte sich an, als hätten wir unser eigenes Abenteuer, das auf unsere Bedürfnisse maßgeschneidert war.\n\nWas uns besonders begeistert hat, war das Gefühl von Freiheit und Flexibilität, das uns das Wohnmobil ermöglichte. Wir konnten unsere Route jederzeit ändern und spontan neue Ziele ansteuern. Das hat uns eine unglaubliche Unabhängigkeit verschafft und ermöglichte uns, das Land auf eine ganz besondere Weise zu erfahren. Wir konnten uns Zeit lassen, um die Schönheit der portugiesischen Landschaft in vollen Zügen zu genießen und uns ganz auf das Abenteuer einzulassen, ohne uns um feste Unterkünfte sorgen zu müssen.\n\nInsgesamt war unser Wohnmobil-Urlaub in Portugal ein Traum, der wahr wurde. Die Kombination aus dem erstklassigen Wohnmobil, den super hilfreichen Tipps von Holger und der Freiheit, das Land auf eigene Faust zu erkunden, machte diese Reise zu einem unvergesslichen Erlebnis für mich und meine Kinder. Wir können es kaum erwarten, wieder zurückzukehren und weitere Abenteuer zu erleben. Vielen Dank an das gesamte Team rund um Holger, welches uns diese unvergesslich schöne Erfahrung ermöglicht hat!"
  },
  {
    "reviewid": "f6a7b8c9-d0e1-2345-f012-34567890abde",
    "stars": 5,
    "name": "Thomas Krull",
    "date": "2023-07-26",
    "text": "Wir waren jetzt das dritte Jahr infolge mit einem Wohnmobil von Holger in Portugal unterwegs... Was soll ich noch groß sagen... Portugal ist das perfekte Land, um mit einem WoMo unterwegs zu sein und Holger ein perfekter Vermieter vor Ort für die WoMos...\nDie Fahrzeuge sind alle top in Schuss und Holger auch echt hinterher, dass das immer so bleibt. Die Campingausstattung in den Autos lässt auch kein Wünsche übrig... Wir haben nie etwas vermisst. Vom Geschirr über Töpfe, Tisch und Stühle, Gläser, Tassen...alles da. Die WoMos sind 12V-autark, dank Solarpanel auf dem Dach. Selbst Fernsehen geht darüber mit automatischer SAT-Anlage. Nur, wer 230V braucht (für einen Fön oder so), der muss sich am Campingplatz an den Landstrom anschließen. Die Markisen an den WoMos sind sehr groß und bieten genügend Schatten an der Eingangsseite.\nAuch der Hol- und Bringservice von bzw. nach Porto klappte immer perfekt.\n\n... ich glaube ja, dass wir auch im nächsten Jahr wieder buchen werden :-)"
  },
  {
    "reviewid": "a7b8c9d0-e1f2-3456-0123-4567890abdef",
    "stars": 5,
    "name": "Afonso Costa",
    "date": "2023-07-08",
    "text": "Ótimo serviço, esclarecimentos de todo o funcionamento da autocaravana, todo o processo transparente. Autocaravanas atuais e todas como novas. Limpeza e estado TOP."
  },
  {
    "reviewid": "b8c9d0e1-f2a3-4567-1234-567890abcdef",
    "stars": 5,
    "name": "Bruno Miguel",
    "date": "2023-07-08",
    "text": ""
  },
  {
    "reviewid": "c9d0e1f2-a3b4-5678-2345-67890abcdef1",
    "stars": 5,
    "name": "Denis Rédua",
    "date": "2023-06-30",
    "text": "Excelente atendimento e a autocaravana impecável. Com certeza volto a alugar com eles."
  },
  {
    "reviewid": "d0e1f2a3-b4c5-6789-3456-7890abcdef12",
    "stars": 5,
    "name": "Luiz Valente",
    "date": "2023-06-29",
    "text": "Excelente, vamos voltar com certeza!\nCinco dias maravilhosos passeando pelo Algarve, eu, minha esposa e nossas duas filhas nos divertimos muito.\nO Holger foi muito prestativo e todo o processo de retirada e devolução da Autocaravana foi muito rápido e fácil.\nA Autocaravana estava impecável, nos sentimos como na nossa casa."
  },
  {
    "reviewid": "e1f2a3b4-c5d6-7890-4567-890abcdef123",
    "stars": 5,
    "name": "GONÇALVES & LOUREIRO, LDA",
    "date": "2023-06-28",
    "text": ""
  },
  {
    "reviewid": "f2a3b4c5-d6e7-8901-5678-90abcdef1234",
    "stars": 5,
    "name": "alexandre Simoes",
    "date": "2023-06-28",
    "text": "Muito bom recomendo"
  },
  {
    "reviewid": "a3b4c5d6-e7f8-9012-6789-0abcdef12345",
    "stars": 5,
    "name": "Vitor Monteiro",
    "date": "2023-06-28",
    "text": "Foi a nossa primeira experiência a alugar uma autocaravana. Fomos em família e conseguimos em poucos dias visitar locais incríveis no nosso país que desconhecíamos. O interior do país está bem servido de apoio para os caravanistas e a autocaravana é moderna, confortável e conduz-se muito bem, e desde o início até à entrega tivemos sempre acompanhamento do Sr. Holger para qualquer dúvida ou problema que surgisse. Recomendamos a 200%!"
  },
  {
    "reviewid": "b4c5d6e7-f8a9-0123-7890-abcdef123456",
    "stars": 5,
    "name": "Helder Mendes",
    "date": "2023-06-28",
    "text": "Excelente experiência, qualidade de equipamentos. Ótimo atendimento, simpatia. Segurança em relação a pagamento e entrega da autocaravana. Limpeza 5*\nAcompanhamento para novatos e disponibilização de pontos de áreas de serviço e parques de estacionamento"
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Jose Rocha",
    "date": "2023-06-15",
    "text": "Tudo perfeito. Boa comunicação prévia, excelente acolhimento e autocaravana irrepreensível!"
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Joel Sousa",
    "date": "2023-05-20",
    "text": "Desde o primeiro contacto o sr. Holger foi muito profissional e prestável que nos deixou com confiança para esta experiência com duas crianças. Foi impecável! A autocaravana é Top e com tudo para proporcionar uns dias memoraveis. Serviço 5 estrelas. Para repetir."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "jose azevedo",
    "date": "2023-05-18",
    "text": "É uma empresa de verdadeiros profissionais. Foi a minha primeira experiencia e desde o primeiro momento que nos foi concedido todo o apoio sem uma unica falha. Alugamos três caravanas (grupo de três casais) . As autocaravanas foram nos entregues em estado imaculado, num estado de conservação ímpar e sem qualquer tipo de problema.\nNuma classificação de 0 a 5 estrelas,  daria 6.\nUma palavra de reconhecido agradecimento a toda a organização e em especial ao Holger, pela simpatia e profissionalismo a todos os níveis."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Paulo Urbano",
    "date": "2023-05-15",
    "text": "Foi uma primeira experiência fantástica, a autocaravana foi entregue em excelente condição, muito bem equipada e tudo funcionou na perfeição. Todo o processo de aluguer foi tratado de forma muito profissional e eficiente.\nRecomendo vivamente."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Rui Dias",
    "date": "2023-05-10",
    "text": "Foi a nossa primeira experiência em autocaravana. O Sr. Holger é um anfitrião excelente e explicou tudo que necessitamos para desfrutar de uns dias memoráveis. A autocaravana é recente e estava em perfeitas condições. Uma experiência a repetir sem dúvida. Todo o processo de aluguer,recolha e entrega foi fácil e transparente. Fantástico."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "milla corrente",
    "date": "2023-05-09",
    "text": "Foi nossa primeira experiência. Eu e minha família amamos estar viajando em uma autocaravana da @minhaautocaravana recomendo e encorajo a quem tem vontade de viajar assim, proprietário e veículo 5 estrelas."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Bruno Martins",
    "date": "2023-04-20",
    "text": ""
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Washington Leite",
    "date": "2023-04-20",
    "text": ""
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Nuno Neves",
    "date": "2023-04-18",
    "text": "Primeira experiência e adoramos. As autocaravanas são impecáveis assim como o proprietário."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Renata Descamps Marquez",
    "date": "2023-04-16",
    "text": "Camping-car super bien équipe et très bien entretenu: comme neuf !\nLe propriétaire Holger fait un super accueil et consacre le temps qu’il faut pour la prise en main du camping car. Nous conseillons vivement."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Joao Carlos Jorge",
    "date": "2023-01-15",
    "text": "Excelente autocaravana para passeios e bom preço"
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Milena Lopes",
    "date": "2022-10-20",
    "text": "Super recomendo! Tivemos uma excelente experiência com a autocaravana e com o atendimento."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "André Branco",
    "date": "2022-09-20",
    "text": "Excelente serviço e simpatia. Adoramos a experiência e recomendamos vivamente. Autocaravana em excelente estado."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Daniel Werner",
    "date": "2022-09-18",
    "text": "Alles super! Es war ein schöner Urlaub und der erste mit Wohnmobil. Die Wohnmobile sind voll Deluxe, Holger mega, das Land und die Leute auch super. Gerne wieder…."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Marco Nellessen",
    "date": "2022-08-20",
    "text": "Top Service. Sehr unkompliziert vor und während der Reise per WhatsApp. WoMo top ausgestattet. Handtücher, etc. alles an Bord... Pickup and return an Flughafen ebenfalls sehr unkompliziert..."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "crystina fernandes",
    "date": "2022-08-18",
    "text": "Alugamos pela primeira vez uma autocarravana, uma experiência muito boa,a repetir.Graças ao Sr Holger  que foi incansável."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Pedro Lobo",
    "date": "2022-08-16",
    "text": "Excelente serviço!\nA caravanas são recentes e estão impecáveis!\nO serviço também foi 5 estrelas (o Holger está sempre disponível), recomendo a todos, incluindo também a quem nunca tenha experimentado :)"
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Joaquim Cabral",
    "date": "2022-07-20",
    "text": "Excelente serviço. Autocaravana em excelente estado e muito ágil, pontualidade na entrega, instruções de utilização bem detalhadas e ainda melhor transmitidas no acto do levantamento, todos os manuais a acompanhar o equipamento, disponibilidade para, em caso de necessidade, dar apoio ou tirar dúvida, durante as 24 horas do dia e uma garrafa de bom vinho para acompanhar ao jantar. A dar pontuação seriam 5 estrelas. Recomendo e tenciono repetir a experiência."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "São Silva",
    "date": "2022-07-18",
    "text": "Adorei a experiência.\nAutocaravana impecável, moderna e muito cuidada.\nO proprietario, Sr. Holger é muito atencioso, simpático e disponível.\nIrei repetir e recomendo.*****"
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Tero Mota",
    "date": "2022-07-16",
    "text": "Foi a minha primeira vez numa aventura com autocaravana sem dúvida voltar a repetir e desfrutar ainda mais pois agora já tenho mais conhecimento que o meu Amigo Holger assim o partilhou"
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Joaquim Sousa",
    "date": "2022-07-10",
    "text": "Acabei ontem de entregar a autocaravana que aluguei ao proprietário e agora Amigo Holger. Não podia deixar de fazer o meu comentário 5* , porque a experiência da viagem, da viatura e do proprietário foram muito positivas.  Já  tinha experiência anterior de férias em autocaravana e estas férias serviram para matar saudades e valeu!!!"
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "PEDRO BATISTA",
    "date": "2022-06-20",
    "text": "Boa tarde Sr. Pedro, obrigado pela a sua avaliação. Por curiosidade, como podemos melhorar na sua opinião o nosso serviço para receber as 5 estrelas?\nMuito obrigado"
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Jan Meyer",
    "date": "2022-06-18",
    "text": "Absolut empfehlenswert. Die Wohnmobile sind sehr modern, gut ausgestattet und top gepflegt. Der Service vor Ort war für uns als Einsteiger in die Welt der Wohnmobile sehr hilfreich und die vielen Tips im Vorfeld wie auch vor Ort haben den den Uraub für uns entspannter gemacht. Wir sind insgesamt wirklich sehr zufrieden."
  },
  {
    "reviewId": "",
    "stars": 5,
    "name": "Joana Machado",
    "date": "2022-06-10",
    "text": "Muito obrigado ☺️"
  },
  {
    "reviewId": "3888246c-1dbc-4b29-be63-7458c6217dca",
    "stars": 5,
    "name": "Gianluigi",
    "date": "2019-11-01",
    "text": "It was my first time and everything was absolutely amazing. The host was great: he explained me everything and in an easy way. During the trip the host was always ready to help me with anything. The motorhome was perfect: new, clean, easy to use and fast!"
  },
  {
    "reviewId": "e8559eda-8544-4e7e-8867-b587b52cc7a9",
    "stars": 5,
    "name": "Adrian",
    "date": "2019-10-01",
    "text": "Fahrzeug: in einwandfreiem Zustand. Grösse für 4 erwachsene Personen ok, mit Koffer etc. aber dann auch eher eng. \n\nVermieter: wir hatten bereits vor der Reise sehr hilfreiche Informationen erhalten. Im Mailkontakt sehr rasche und wertvolle Antworten. Die Übergabe pünktlich und mit einwandfreier Instruktion. Also alles perfekt :-)\n\nUrlaub: Portugal ist ein wunderschönes Land. Man kann alles erleben (Stadt, Land, Meer, ...). Und aus meiner Sicht ist der Camper die perfekte Art das Land kennen zu lernen. Einzig beim Wildcampen an der Algarve hatten wie einmal Kontakt mit der Polizei. Welche allerdings sehr freundlich war und uns zwar verwarnt hat, aber dann doch übernachten liess. Die Campingplätze sind in äusserst unterschiedlichem Zustand. Hier helfen z.B. Google-Rezensionen weiter..."
  },
  {
    "reviewId": "42641e99-6ee8-4307-88cf-ff54d87a385c",
    "stars": 5,
    "name": "Olga",
    "date": "2019-10-01",
    "text": "Thanks a lot, everythink perfect. Pickup and dropoff Lisbon without any Problem. \n\nIt was a great pleasure, we had some beautiful days."
  },
  {
    "reviewId": "6c5c16e4-ad81-426e-a919-f58585cc8103",
    "stars": 5,
    "name": "Mark",
    "date": "2019-07-01",
    "text": "The vehicle was very comfortable and was able to fit us all in without issues Holger was great and very helpful with our questions both before and during the rental. We were a family of 5. 7, 10, 45,46 and 79 years old and found it a dream as was comfortable. Thanks for the rental"
  },
  {
    "reviewId": "dddeec5e-07cf-4c7d-9def-93505d64b120",
    "stars": 5,
    "name": "Marco",
    "date": "2019-06-01",
    "text": "Correu tudo super bem. O Holger e a Elisabete são super simpáticos e estão sempre prontos a ajudar. A autocaravana é excelente e tem tudo o que é necessário para umas férias excelentes. Super recomendamos e se voltarmos a repetir vai ser com a Elisabete e o Holger de certeza!"
  },
  {
    "reviewId": "660e9ff3-0321-47d0-8827-f0a9c327506e",
    "stars": 5,
    "name": "Benjamin",
    "date": "2019-06-01",
    "text": "Everything perfect! Everything like reserved! It was a great pleasure for us!"
  },
  {
    "reviewId": "33d7f64a-8994-42ce-a761-985c03a14730",
    "stars": 5,
    "name": "Jose",
    "date": "2019-06-01",
    "text": "First of all congratulations for what you do and how you do it. For us it was a jouney we will never forgett and you were part of that. It was simply amazing. The van had everything we needed."
  },
  {
    "reviewId": "d45abab4-5bc3-436d-81e9-420094d7a87e",
    "stars": 5,
    "name": "Johann",
    "date": "2019-04-01",
    "text": "Sehr netter und entgegen kommender Vermieter, alles top wie beschrieben und ausgemacht, vielen herzlichen Dank!!! Das Wohnmobil war für uns super, mit allem ausgestattet,, was man so braucht! Sogar Handtücher und Bettwäsche inklusive!"
  },
  {
    "reviewId": "09c9df99-0af3-49da-9c21-ab9621aced63",
    "stars": 5,
    "name": "Mark",
    "date": "2019-04-01",
    "text": "Could not have been nicer to deal with, and the motorhome was flawless. Thanks guys!"
  },
  {
    "reviewId": "8e7b544a-1d0e-40d9-82ef-6395fd7d4b2c",
    "stars": 5,
    "name": "Luis",
    "date": "2018-11-01",
    "text": "Cumpre o que promete, para repetir!"
  },
  {
    "reviewId": "365cf151-cff9-4d59-99c0-9edf759355e5",
    "stars": 5,
    "name": "Valentin",
    "date": "2018-10-01",
    "text": "Exceptionnel, tout était parfait, le propriétaire est très sympathique, arrangeant et plein de bons conseils.\n\nLe camping-car est neuf, tout est fonctionnel et bien pensé, nous avons passé un magnifique séjour, je recommande à 100% vous pouvez y aller les yeux fermés.\n\nMerci encore"
  },
  {
    "reviewId": "1db59788-2e8c-460d-b52c-a82b404a36fe",
    "stars": 5,
    "name": "Andreas",
    "date": "2018-10-01",
    "text": "Was sollen wir sagen, es ist eigentlich ganz einfach:\n\nWir sind rundum glücklich und zufrieden. Wir haben ein wunderbares Land kennengelernt. Die Voraussetzungen waren die Vorbereitung, die Tipps und die Unterstützung der Vermieter, die einem mit Rat und Tat zur Seite stehen.\n\nDas findet man nicht so oft! Wir kommen sehr gern wieder und freuen uns schon auf unseren nächsten Besuch."
  },
  {
    "reviewId": "a6cf9689-05c9-4cc7-bda7-ca7d983a37fd",
    "stars": 5,
    "name": "Benjamin",
    "date": "2018-09-01",
    "text": "Holger and Elisabete are both very welcoming and helpful. Gave us some useful tips for our trip. \n\nThe motohome is clean, well equipped and in prefect condition. I went with 2 toddlers, it was great having a well equipped kitchen where I can make proper dinners every night.\n\nI highly recommend it and will definitely hire it again.\n\nThanks for renting your mobile home to us."
  },
  {
    "reviewId": "04524814-cbf5-40c3-acaf-7e5cae4fa9ba",
    "stars": 5,
    "name": "Miguel",
    "date": "2018-09-01",
    "text": "Muy buena experiencia, muy bien mantenida, aprendiendo un poco como es el sistema de alquiler, tips importantes que aprendi que la limpieza debes hacerla  previo a la entrega no funciona como un Carro de alquiler normal, el agua debes usarla con prudencia. Anabel muy amable su esposo un poco extricto como buen aleman pero simpatico tambien. La recomiendo 100% lo volveria hacer gracias por la pasciencia de no leer muchos aspectos. Tienen la posibilidad de llevartela a donde quieras según pregunte."
  },
  {
    "reviewId": "ec1c429c-64f7-4457-9165-379021b9c8d8",
    "stars": 5,
    "name": "Maria Teresa Da",
    "date": "2018-09-01",
    "text": "O aluguer foi muito fácil e a comunicação com os proprietários foi perfeita, quer durante o processo de aluguer, quer durante a viagem."
  },
  {
    "reviewId": "3ce89d96-f8ca-41bf-b8d0-2a50ee5ddcf0",
    "stars": 5,
    "name": "Pedro",
    "date": "2018-08-01",
    "text": "A nossa primeira experiência em autocaravanismo não poderia ter sido melhor. Os proprietários são pessoas extraordinárias de uma amabilidade difícil de encontrar. A autocaravana é magnífica a todos os níveis. A repetir!!!"
  },
  {
    "reviewId": "7a3fd325-b8db-429d-9603-aed73e4c2c66",
    "stars": 5,
    "name": "Diana",
    "date": "2018-08-01",
    "text": "Adorámos a nossa passeata de autocaravana, tudo limpinho e não faltou nada.\n\nVamos repetir…"
  },
  {
    "reviewId": "04bc9fb1-bfdf-466c-82f9-6f3f5d56cbbe",
    "stars": 5,
    "name": "Kerstin",
    "date": "2020-03-01",
    "text": "Wir hatten eine wunderbare Reise. Schon vor und natürlich während der Reise wurden alle unsere Fragen ausführlich, prompt, super freundlich und hilfreich beantwortet und dazu noch Tipps gegeben.\n\nÜbergabe einwandfrei, das Wohnmobil hat eine praktische und komfortable Ausstattung, nix hat gefehlt, alles hat sehr gut funktioniert und ist in sehr gutem Zustand.\n\nRückgabe auch super, inkl. Abrechnung und Kautionsrückzahlung.\n\nAbsolut faire Abwicklung bei Reparatur, da wir einen kleinen Schaden verursacht hatten. \n\nHat alles bestens funktioniert!"
  },
  {
    "reviewId": "d63a4457-6032-4566-9e48-54ff9c49c894",
    "stars": 5,
    "name": "Ginny Carla",
    "date": "2020-03-01",
    "text": "Experiência maravilhosa. Foi nossa primeira viagem de motorhome/autocaravana e foi tudo maravilhoso.\n\nElisabete foi super solícita ao dar informações antes e Holger, ao entregar o veículo, fornecendo todas as explicações necessárias. \n\nA autocaravana é bem confortável, segura e tem todos os utensílios necessários para uma viagem tranquila e prazerosa. \n\nSó tenho elogios. Espero poder fazer outras viagens assim!!\n\n \n\n=)\n\n \n\n-----Wonderful experience!!!"
  },
  {
    "reviewId": "1f917534-3f3f-43ab-af4c-a3452fac3aff",
    "stars": 5,
    "name": "Sérgio",
    "date": "2020-01-01",
    "text": "O Holger e a Elisabete são pessoas super acessiveis e preocupadas com o bem estar do cliente! A autocaravana é espectacular! Tudo muito limpinho e com tudo o que é necessário para realizar umas férias em familia.\n\nMuito obrigada Holger e Elisabete por nos deixarem disfrutar do vosso carro e assim concretizar o desejo dos nossos filhos. Vamos voltar a alugar convosco, sem dúvida!!\n\nBeijinhos da nossa familia para vós e desejos de um 2020 repleto de concretizações!\n\nAna e Sérgio"
  },
  {
    "reviewId": "f90b630d-a153-4f18-9d3c-852f80e12dbf",
    "stars": 5,
    "name": "Daniela",
    "date": "2019-11-01",
    "text": "Realmente o mais correcto é mesmo 5 estrelas. Fomos recebidos com uma enorme simpatia e disponibilidade para nos ensinarem todos os promenores do veículo. Resumidamente foi uma viagem sem precalços, super confortável mesmo em dias de chuva, manutenção do veículo super acessível. Voltaremos sem dúvida a repetir a experiência. E sem dúvida que recomendamos este veículo, tem todos os confortos de uma casa. Um enorme abraço aos responsáveis"
  },
  {
    "reviewId": "de8eade9-055e-4af0-a0fe-5c03aa01106a",
    "stars": 5,
    "name": "Michael",
    "date": "2019-11-01",
    "text": "We had a very good trip through Portugal with this caravan. It is very comfortable equipped(even for more persons) and has everything you need on board. Holger was very friendly and flexible with our arrivals and departures, also the communication was quick and easy. When you arrive you get a detailed explanation how everything works, also Holger had some extra tipps for us. :) Have fun!"
  },
  {
    "reviewId": "6b82507d-8fd3-4fce-90a4-6deaebc529a6",
    "stars": 5,
    "name": "Wolfgang",
    "date": "2019-10-01",
    "text": "Klasse Übergabe des Fahrzeugs direkt am Flughafen. Gründliche Einführung, rundum super Betreuung. Wir waren zu fünft unterwegs mit drei Kindern im ALter von 4,10 und 15 Jahren. Genügend Raum für alle! Auch bei der Rückgabe des Fahrzeugs wurde ganz auf unsere Wünsche eingegangenwas Ort und Zeit betrifft. Vielen Dank dafür-waren tolle 10 Tage Portugal für uns."
  },
  {
    "reviewId": "91c4e6a1-58ea-4aa4-9e5f-7d385dbd2d71",
    "stars": 5,
    "name": "Peter",
    "date": "2019-08-01",
    "text": "Von Start bis Ankunft empfehlenswert - toller Wagen und toller Service!\n\nHolger hat uns von Anfang an gut beraten und nicht zu viel versprochen: Der Wagen ist hervorragend eingerichtet, sehr gepflegt und an alles ist gedacht. Die Atmosphäre ist gemütlich und hell und nicht so muffig wie viele alte Wohnmobile.\n\nZu viert war beinah zu viel Platz! Alle Einrichtungen sind hochwertig, die Küche ist gut ausgestattet, das Badezimmer ist geräumig genug und überall gibt es genug und schlau verbauten Stauraum. Holger hat zusätzliche Verdunkelung angebracht, so daß man den gesamten Wagen vor Blicken schützen kann und bei starker Sonne geschützt ist. Auch für das Leben draußen ist alles da: EIn großer Sonnenschutz und eine komplette Campingtischausstattung mit Stühlen.\n\nDer Wagen lässt sich trotz der Größe gut fahren. Die Rückfahrkamera war häufig sehr nützlich.\n\nAuch Abholung und Rückgabe haben hervorragend geklappt, Holger ist sehr zuverlässig, reagiert schnell auf Mails, gibt vor Ort eine gute Einführung und hat gute Tipps parat für Stellplätze, die Abrechnung der Maut und Einkäufe. Wir hatten zwischendurch ein paar Fragen die schnell via SMS oder Telefonat geklärt wurden. Wir hatten auch im Vorfeld Gasflaschen für unseren extra Kocher mit der Post an ihn geschickt, auch das hat alles geklappt.\n\nWenn wir wieder eine Tour in Portugal machen werden wir sicher wieder bei Holger buchen!"
  },
  {
    "reviewId": "2c52bcde-d6d0-41a0-ade7-788fc142f3f4",
    "stars": 5,
    "name": "Manuel",
    "date": "2019-08-01",
    "text": "Como primeira experiência foi espetacular, desde todo o apoio prestado, durante viagem (aventura),até à entrega. São pessoas incríveis.\n\nUma aventura que queremos repetir.\n\nObrigado por tudo"
  },
  {
    "reviewId": "5e78c479-0990-4333-b992-eee8a40421db",
    "stars": 5,
    "name": "José Carlos",
    "date": "2019-08-01",
    "text": "O acolhimento,acessibilidade e gentileza....fazem parte da vossa atividade(minha autocaravana)estamos gratos pelo serviço prestado,obrigados e até breve."
  },
  {
    "reviewId": "7431e841-09c0-4952-a258-393a681ba3da",
    "stars": 5,
    "name": "Carla",
    "date": "2019-08-01",
    "text": "Caravana é maravilhosa, óptimas condições, fácil de conduzir e estacionar.Proprietário super simpático, explicação de todo o véiculo muita cuidada. O propreitário e a caravana tornaram a experiência incrível."
  },
  {
    "reviewId": "a901b560-bab4-4fb7-9d9f-46abc089c38d",
    "stars": 5,
    "name": "Jorge",
    "date": "2019-07-01",
    "text": "Um sonho!\n\nVeículo impecável, novo, deste ano. Estávamos 5 pessoas com todo o conforto e espaço. Condução muito fácil. O proprietário de uma simpatia extrema.\n\nLamento não ter uma área de melhoria a apontar :-)\n\nFicamos a aguardar pela próxima!"
  },
  {
    "reviewId": "e1a19abf-803a-4ad2-a777-f9025dfa24cf",
    "stars": 5,
    "name": "Manuel",
    "date": "2019-06-01",
    "text": "Sendo a nossa primeira experiência, iamos com alum receio de não gostar ou de algo não correr bem. No entanto, após a chegado ao local de recolha fomos extremamente bem acolhidos e recebemos uma mini-formação fantástica que permitiu que usufruissemos de uns dias em aventura!\n\nA autocaravana estava impecavelmente limpa, com todo o conforto e tem tudo para passar uns dias tranquilos e sem preocupações!\n\nUma experiência a repetir!"
  },
  {
    "reviewId": "6ff94697-0434-43ae-9d2c-25eeac272a16",
    "stars": 5,
    "name": "David",
    "date": "2019-09-01",
    "text": "Very good experience. Rental agent was very helpful and accommodating. He delivered to and picked up motorhome from our campsite. Unit was clean and well maintained. I would recommend using Elisabete’s motorhomes."
  },
  {
    "reviewId": "2cb40427-4ea3-48e4-93b9-2927ab774d6b",
    "stars": 5,
    "name": "Harald",
    "date": "2019-09-01",
    "text": "Als Rahmenbedingungen sollte kurz erklärt werden, wir waren zu viert (2 Erwachsene, 2 Kinder mit 9+13 Jahren) eine Woche in Portugal unterwegs. Ich selbst bin Laie in Sachen Wohnmobil und war das erste Mal mit einem selbigen unterwegs, hatte im Vorfeld auch wenig Erfahrung mit größeren Fahrzeugen, Anhängern etc., was mich schon ein wenig nervös gemacht hat. Vorne weg gesagt, die Angst war unbegründet. Der Kontakt mit dem Vermieter war vom Anfang an problemlos, der deutsche Besitzer hat sich bereits im Vorfeld stets und unverzüglich auf alle Anfragen via Mail (bzw. Whatsapp) gemeldet und freundlich Auskunft erteilt. Beim ersten persönlichen Kontakt hat er sich mit der Übergabe und Einschulung auf das Fahrzeug viel Zeit gelassen und alles in Ruhe erklärt, die Übergabe und Rückgabe waren völlig unkompliziert. Auch während der Reise war der Vermieter jederzeit tel. erreichbar und hat freundlich weitergeholfen, das hat uns schon ein gutes Gefühl gegeben. Über das Fahrzeug selbst kann ich wenig über technische Details, dafür eher praktisches Berichten. Das Wohnmobil hat für uns 4 platzmäßig völlig ausgereicht, es ist genug Stauraum vorhanden und auch der Schlafcomfort war (an allen Fenstern Insektengitter) in Ordnung. Das Fahren war auch für einen Laien einfach (gelobt sei die Rückwärtskamera), wenngleich man sich schon erst auf die Größe des Fahrzeugs einstellen muss. Bad/Küche/WC war alles top, von außen hat der Wagen schon ein paar Kratzer (hab ich aber eher als Vorteil gesehen, von wegen Angst mal irgendwo mal anzuschrammen). Navi und Fernseher sind dabei, ein großer Vorteil war das integrierte Autobahnbezahlsystem, sodass ohne irgendwelche Tickets etc. zu lösen (ist in Portugal ein etwas kompliziertes System) einfach nach dem Ende der Reise mit dem Vermieter die gefahrenen Autobahnkilometer abgerechnet wurden. Das WLAN hat gut funktioniert und war für die Kids unerlässlich. Fazit: Der Vermieter war immer erreichbar, freundlich, fair, korrekt und kompetent. Die Über- und Rückgabe des Wohnmobils waren unproblematisch. Das Wohnmobil selbst war in gutem Zustand, auch für Laien einfach zu bedienen. Mit diesem Vermieter gerne noch einmal."
  },
  {
    "reviewId": "07f563bb-bba2-45b1-9199-95d36870b1be",
    "stars": 5,
    "name": "Nicolas",
    "date": "2019-08-01",
    "text": "Super experience lors de cette location! Le camping car était très très propre et bien entretenu. Il possède vraiment tout ce dont on a besoin pour un voyage en camping car. Le loueur est super, il a tout fait pour que nous passions un agréable séjour. Ils nous a donné des conseils pour la conduite, des supers lieux pour stationner... Il a également été très attentionné et avait prévu du matériel de puériculture supplémentaire pour nos enfants. Les réponses sont toujours très très rapides! Vraiment super!"
  },
  {
    "reviewId": "e42bc747-e901-428f-8112-ab8a603a8c40",
    "stars": 5,
    "name": "Thomas",
    "date": "2019-07-01",
    "text": "Top! Empfang des Wohnmobiles in Lissabon und Abgabe in Porto ohne Probleme. Das Wohnmobil war in einwandfreiem Zustand.Kommunikation mit dem Vermieter verlief von Anfang an so wie man sich das wünscht."
  },
  {
    "reviewId": "1cd88e6e-0177-477b-9be4-68ed01365611",
    "stars": 5,
    "name": "Jürgen",
    "date": "2019-07-01",
    "text": "Nichts auszusetzen, vom ersten Kontakt bis zuletzt prima Kommunikation. Das Wohnmobil ist absolut neuwertig. Gerne wieder. Selbst das Fahrrad wurde organisiert."
  },
  {
    "reviewId": "0f752914-85e5-4904-8e43-33c7eb3297ef",
    "stars": 5,
    "name": "Pedro",
    "date": "2019-06-01",
    "text": "Excelente!!! Dificilmente poderíamos ter encontrado um proprietário mais sério, simpático, atencioso e disponível para esta nossa primeira experiência! O veículo estava em perfeitas condições! Novo, limpo e muito bem equipado! Depois de 10 anos a tentar convencer a minha esposa a alinhar numa aventura desta natureza, agora é ela que quer repetir a experiência! Ficou convencidíssima! A minha filha de 5 anos não tem falado de outra coisa!\n\n5 estrelas para o proprietário, 5 estrelas para o veículo, 5 estrelas para a experiência!\n\nQueremos repetir e iremos partilhar e recomendar!\nArrisquem e não se vao arrepender! ;)"
  },
  {
    "reviewId": "10a3f0f4-f299-484f-a47a-79109b7d990a",
    "stars": 5,
    "name": "Pedro",
    "date": "2019-06-01",
    "text": "Excelente simpatia e comunicação. Autocaravana em perfeito estado, muito bem equipada. Disponibilidade total do proprietário para atender e resolver os pequenos problemas surgidos numa viagem de um neófito nesta matéria...\n\nÚnicas sugestões: \n\n-incluir no aluguer a opção de lavagem / limpeza interior\n\n- Na garagem , colocar aranhas de elástico para que os objectos não andem aos tombos.\n\nEmbora n conheça outros, ficarei fiel ao \"1º amor\" ...:-)"
  },
  {
    "reviewId": "feda0c7d-e7c2-4100-865b-e67455195135",
    "stars": 5,
    "name": "Nicolas",
    "date": "2019-06-01",
    "text": "Perfect conditions, everything included. We really enjoyed our holidays."
  },
  {
    "reviewId": "da3883aa-9383-4b02-ad51-5eb249aac1ca",
    "stars": 5,
    "name": "Nancy",
    "date": "2019-04-01",
    "text": "Todo genial, contestó muy rápido a todas mi dudas. La autocarava es nueva, todo perfecto. Fuimos una pareja, y dos niños pequeños y se nos hizo muy cómodo. Repetiremos seguro, tanto la autocaravana como la zona!!"
  },
  {
    "reviewId": "780a0f7d-e19a-42e5-8b4f-1064ac0d4840",
    "stars": 5,
    "name": "Carlos",
    "date": "2019-11-01",
    "text": "Pessoas muito simpáticas, prestáveis e profissionais. As autocaravanas muito boas e modernas. Obrigado 👌"
  },
  {
    "reviewId": "35df9d5f-efd3-400a-9140-a6ed9051ec5b",
    "stars": 5,
    "name": "Joao",
    "date": "2018-08-01",
    "text": "Autocaravana muito bem equipada com tudo o que se pode precisar para umas férias inesquecíveis . Limpeza 5 estrelas e um ótimo acompanhamento por parte do proprietário que é bastante acessível . Sem duvida a melhor maneira de se conhecer o país . Recomendo"
  },
  {
    "reviewId": "1c5d56b5-eeac-467b-aed9-1a76eca206ec",
    "stars": 5,
    "name": "Stephanie",
    "date": "2019-08-01",
    "text": "Wonderful experience! The motorhome was very clean, in a good condition, well prepared.\nWe have everything for travel like a house.\nHolger, the owner, provided us a lot of support to arrange our trip. He give us some advice for drive, for find some beautiful places...\nSo perfect!!"
  },
    {
    "reviewid": "e7eeab8d-7214-4e65-976a-e0c0d6ee15f5",
    "stars": 5,
    "name": "Toni Domingues",
    "date": "2021-10-14",
    "text": "Fomos pela primeira vez de férias em família numa autocaravana e sem dúvida que iremos repetir. O conforto da autocaravana com tudo o que é necessário e a disponibilidade do Holger para nos ajudar nas nossas dúvidas foi simplesmente fantástico. Recomendo (Translated by Google) We went on a family holiday in a motorhome for the first time and without a doubt we will repeat it. The comfort of the motorhome with everything needed and the availability of Holger to help us with our queries was simply fantastic. I recommend"
  },
  {
    "reviewid": "77200034-9c59-4219-8e81-6cb847dff201",
    "stars": 5,
    "name": "Lurdes Martins-vetter",
    "date": "2021-09-30",
    "text": "Es war ein Traum!!! Das Womo hatte alles, was wir brauchten ( Bettwäsche, Handtücher, Geschirrtücher etc.). Die vorbestellten E-Scooter machten unseren Urlaub noch flexibler. Holger ist ein sehr sympathischer, freundlicher und zuvorkommender Vermieter. Steht jederzeit zur Hilfe bereit! Die Autocaravane war neu, gepflegt, bequem und super ausgestattet. Immer wieder gerne und sehr zu empfehlen. Vielen lieben Dank"
  },
  {
    "reviewid": "4253d64f-6b7e-43cf-8e4e-1c6d25da0d56",
    "stars": 5,
    "name": "Falk S.",
    "date": "2021-09-23",
    "text": "Wir haben zu viert das zweite Mal Urlaub im Wohnmobil gemacht. Das Auto war neuwertig, modern und top gepflegt, der Service war nicht zu verbessern (Abholservice vom Flughafen, Kofferaufbewahrung...). Holger war bei Fragen stets erreichbar, er hat immer ein oder zwei Tipps für die Reise gehabt. Als die Airline unser Gepäck verloren hatte, hat er sich um die Anlieferung der Koffer gekümmert und sie uns hinterher gefahren! Auch Portugal hat sich so vielseitig und wunderbar gezeigt, wie wir es nicht erwartet hätten. Wir waren auf der Reise nicht nur am Strand, sondern auch in den Bergen, Naturparks, in Weinanbaugebieten und und und. Es ist für einen Urlaub im Wohnmobil ein traumhaftes Ziel! (Translated by Google) The four of us went on vacation in the motorhome for the second time. The car was new, modern and well maintained, the service could not be improved (airport pick-up, luggage storage ...). Holger was always available for questions, he always had a tip or two for the trip. When the airline lost our luggage, he took care of the delivery of the suitcases and drove them after us! Portugal has also shown itself to be so versatile and wonderful that we would not have expected. On the trip we were not only on the beach, but also in the mountains, nature parks, in wine-growing areas and and and. It is a dream destination for a vacation in a motorhome!"
  },
  {
    "reviewid": "064f8978-74ee-489a-8e9b-8bbe8698022e",
    "stars": 5,
    "name": "Raquel Santos",
    "date": "2021-09-05",
    "text": "Uma semana fantástica com excelentes condições para 5 pessoas."
  },
  {
    "reviewid": "9fc48b09-aee7-4c5a-80d5-c61d263d9ac7",
    "stars": 5,
    "name": "Miguel Gomes",
    "date": "2021-08-15",
    "text": "Muito bom serviço. Autocaravana impecável. Foram umas férias para repetir e recomendar. Obrigada Holger. (Translated by Google) Very good service. Impeccable motorhome. It was a vacation to repeat and recommend. Thank you Holger."
  },
  {
    "reviewid": "62d8eca4-37bd-483f-b70a-2c384c30c1e9",
    "stars": 5,
    "name": "Dany seibert",
    "date": "2021-07-11",
    "text": "Super recomendo, carro novo em ótimo estado, não tivemos problema nenhum. (Translated by Google) I highly recommend it, new car in great condition, we had no problem."
  },
  {
    "reviewid": "f6e299e6-9e81-476f-be3f-8b669fb5dccd",
    "stars": 5,
    "name": "rosamaria paispinto",
    "date": "2021-07-12",
    "text": "Foi a nossa primeira experiência, mas recebemos do proprietário uma mini formação fantástica e esteve sempre disponível durante a viagem para tirar algumas dúvidas que íam surgindo. Excelente autocaravana, limpa e muito bem equipada para umas férias inesquecíveis. Recomendamos vivamente o aluguer nesta empresa. (Translated by Google) It was our first experience, but we received a fantastic mini-training from the owner and he was always available during the trip to answer any questions that arose. Excellent motorhome, clean and very well equipped for an unforgettable holiday. We highly recommend renting from this company."
  },
  {
    "reviewid": "da554a17-ae06-424f-a1e5-8369b8912961",
    "stars": 5,
    "name": "adao cardoso",
    "date": "2021-06-18",
    "text": "Excelente experiência, proprietário sempre disponível e viatura com óptimas condições. Vale a pena experimenter. (Translated by Google) Excellent experience, owner always available and car in excellent condition. It's worth experimenting."
  },
  {
    "reviewid": "66532292-7eed-44ac-8a79-109e39745d22",
    "stars": 5,
    "name": "maria belen alsina",
    "date": "2021-06-01",
    "text": "It was a great experience! Holger was super available and explained everything to us! Great way to enter in the camper world!"
  },
  {
    "reviewid": "638d6d08-ee1d-4dbf-88cf-1b7ea5bb8d46",
    "stars": 5,
    "name": "Maria Dacruz",
    "date": "2021-05-20",
    "text": "5 estrelas!"
  },
  {
    "reviewid": "71638258-7d85-4637-b078-fd18a895d121",
    "stars": 5,
    "name": "Emídio Francisco",
    "date": "2021-03-12",
    "text": "5 estrelas!"
  },
  {
    "reviewid": "13e0b33d-1bae-4b89-a0d1-ae7b3cd5a7da",
    "stars": 5,
    "name": "Elder Pinto",
    "date": "2021-02-11",
    "text": "Gestão 5*****. Holger sempre disponíveis. Foi muito bom ter conhecido e recomendo. Obrigado (Translated by Google) Management 5 *****. Holger always available. It was great to have known and recommend. Thanks"
  },
  {
    "reviewid": "3c8b74d3-a70e-4217-9ec1-7403813cc705",
    "stars": 5,
    "name": "Pedro Andrade",
    "date": "2021-02-05",
    "text": "Fantástica experiência. Caravanas super modernas , confortáveis e adoráveis de se conduzir. Nunca tinha andado numa , e eu , esposa e 3 filhas ficamos fãs ! O Sr Holger da toda a informação em detalhe para um passeio ou férias em descanso e tranquilidade com toda a informação sobre o que precisamos de saber. Muito recomendado. (Translated by Google) Fantastic experience. Super modern caravans, comfortable and lovely to drive. I had never been to one, and I, wife and 3 daughters became fans! Mr Holger gives all the information in detail for a walk or holiday in rest and tranquility with all the information about what we need to know. Very recommended."
  },
  {
    "reviewid": "8f3367fb-c201-45d2-81be-a0600f7e3d56",
    "stars": 5,
    "name": "João Pedro Martins",
    "date": "2021-02-04",
    "text": "Excelente relação preço/qualidade! Muito profissionalismo e disponibilidade total para o que fosse necessário durante a utilização. A autocaravana em ótimo estado, muito limpa e com tudo o que fosse necessário. Sem dúvida a minha empresa de eleição sempre que precisar de uma autocaravana! (Translated by Google) Excellent price / quality ratio! Much professionalism and total availability for whatever was needed during use. The motorhome in great condition, very clean and with everything that was necessary. Without a doubt my company of choice whenever you need a motorhome!"
  },
  {
    "reviewid": "37640fef-0a70-43a2-bb4e-563dcb354111",
    "stars": 5,
    "name": "Nuno Mendes",
    "date": "2021-02-04",
    "text": "Sempre um óptimo serviço e autocaravanas sempre impecáveis. (Translated by Google) Always a great service and motorhomes always impeccable."
  },
  {
    "reviewid": "aface35c-d56f-46a6-82e9-b345d8efa5a2",
    "stars": 5,
    "name": "Rafael Marcelino",
    "date": "2021-02-03",
    "text": "Tive uma das melhores experiências da minha vida. Obrigado Holger e equipe pelo excelente serviço prestado. Caravana em perfeitas condições, fomos super bem instruídos no uso de todos componentes da mesma. Preço justo e companheiros na viagem . Parabéns, recomendo 100% (Translated by Google) I had one of the best experiences of my life. Thank you Holger and team for the excellent service provided. Caravan in perfect condition, we were very well instructed in the use of all its components. Fair price and companions on the trip. Congratulations, I recommend 100%"
  },
  {
    "reviewid": "82f71f64-09a5-4441-9fd9-d73085252940",
    "stars": 5,
    "name": "Rosa Manu",
    "date": "2021-02-01",
    "text": "Muito bom serviço e simpatia 👌👌 (Translated by Google) Very good service and friendliness 👌👌"
  },
  {
    "reviewid": "bd926c97-c42c-4136-aa1e-73919fa73747",
    "stars": 5,
    "name": "Liliana Almeida CABELEIREIROS",
    "date": "2021-01-28",
    "text": "Melhores autocaravanas, muito conforto, modernas, de muita confiança, a melhor experiência de férias com a familia, muito obrigado , recomendo 💯 (Translated by Google) Best motorhomes, very comfortable, modern, very reliable, the best family vacation experience, thank you very much, I recommend 💯"
  },
  {
    "reviewid": "2e6cd3ef-997b-4cea-b2b3-edadc9bff7bd",
    "stars": 5,
    "name": "Steve Oliveira",
    "date": "2021-01-28",
    "text": "Primeira experiência em autocaravana com muita aventura, conhecimento e descobertas... excelente!! Experiência a repetir... (Translated by Google) First motorhome experience with lots of adventure, knowledge and discoveries ... excellent !! Experience to repeat ..."
  },
  {
    "reviewid": "7193fde6-c3ef-44e4-b235-042106d9d2c0",
    "stars": 5,
    "name": "Ângelo Valente",
    "date": "2021-01-27",
    "text": "Foi a nossa primeira experiência em aluguer de Caravanas e ficámos rendidos. Caravanas modernas, super bem equipadas e a formação dada foi essencial para tirarmos todo o proveito da viagem. A disponibilidade é total para em qualquer momento, por telefone esclarecer todas as dúvidas. Aconselho vivamente. (Translated by Google) It was our first experience in caravan rental and we were surrendered. Modern, well-equipped caravans and the training given was essential to make the most of the trip. Availability is total so that at any time, by phone, clarify all doubts. I strongly advise."
  },
  {
    "reviewid": "9b5e85cc-8fea-4d18-9560-18152fb5da15",
    "stars": 5,
    "name": "Andrew Riedel",
    "date": "2021-07-08",
    "text": "What a great experience! As first timers we really appreciated the time Holgar took to explain everything in detail. The motorhome was almost new and superbly equipped and in good working order. Our hire was for 7 days and we loved it. Now it’s time for us to buy our own unit. Thanks Holgar for all your help!"
  },
  {
    "reviewid": "1df6fd76-69ab-4cf8-9c57-b24ecc12166d",
    "stars": 5,
    "name": "Daniel Richter",
    "date": "2021-08-23",
    "text": "Es passte wirklich alles. Service von A bis Z mit super Fachkompetenz und tollen Tips für die besonderen Hotspots. Merci Holger !!!"
  },
  {
    "reviewid": "f667bdf2-913a-4c9e-a9ad-a0d4d443fb9a",
    "stars": 5,
    "name": "Catia Gomes",
    "date": "2021-08-22",
    "text": "Autocaravana em excelentes condições, o que nos proporcionou uma viagem fantástica de sete dias pelo Gerês. Recomendo."
  }
];
  return vehicleRatings;
}

export async function specials() {
  let response = await fetch('https://'+apiUrl+'/specials');
  let data = await response.json();
  // filter the given dictionary specials, so that only those items remain 
  // where fromDate >= today and today between validFrom and validTo
  const specialsActive = data.Items.filter(
      (special) => {
        const today = new Date().toISOString().split('T')[0];
        return (
          special.validFrom<=today && special.validTo >= today
        );
      }
  );
  return specialsActive;
}

export async function seasons() {
  let response = await fetch('https://'+apiUrl+'/configs');
  let data = await response.json();
  return data.Items;
}

export async function blockedDates(/*f, err, camperId*/) {
  //console.log('function: load blocked dates: ');
  let response = await fetch('https://'+apiUrl+'/unavailable-dates');
  let data = await response.json();
  //console.log('got blockedDates', data);
  return data;
 //f(data, camperId);
      // .then(res => {
      //   return res.json();
      // })
      // .then(data => {
      //   ////console.log(data);
      //   f(data, camperId);
      // },
      // // Note: it's important to handle errors here
      // // instead of a catch() block so that we don't swallow
      // // exceptions from actual bugs in components.
      // (error) => {
      //   err(error);
      //   //console.log(error);
      // });
}

export async function campers(/*f, err*/) {
  let response = await fetch('https://'+apiUrl+'/campers');
  let data = await response.json();
  return data.Items;
}

export function PostBookingRequest(params) {
  let apiUrl = 'https://o95nosfn1a.execute-api.eu-central-1.amazonaws.com/dev';
  const searchParams = Object.keys(params).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        }).join('&');
  fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    body: searchParams
  });
}

// export {
//   Translations,
// };